function getLessonNumber(asset) {
  return parseInt(asset?.name?.match(/\d+/)?.[0] || '0', 10);
}

/** Subscription plan lessons only (excludes curriculum-topic cards). */
export function getSubscriptionLessons(assets) {
  return (assets || [])
    .filter((asset) => asset.type !== 'curriculum')
    .sort((a, b) => {
      const numA = getLessonNumber(a) || 9999;
      const numB = getLessonNumber(b) || 9999;
      if (numA !== numB) return numA - numB;
      return (a.name || '').localeCompare(b.name || '');
    });
}

/** Lesson 1 stays available after expiry; later lessons do not. */
export function isSubscriptionLessonSelectable(asset) {
  if (!asset) return false;
  if (asset.isInactive) return false;
  const expired = asset.subscriptionStatus === 'expired' || asset.greyedOut;
  return !(expired && getLessonNumber(asset) !== 1);
}

/** Lessons teachers can pick for missions, quizzes, and curriculum matcher. */
export function getSelectableSubscriptionLessons(assets) {
  return getSubscriptionLessons(assets).filter(isSubscriptionLessonSelectable);
}

/** Video/thumbnail data for lesson cards and the player modal. */
export function getAssetVideoPlayback(asset) {
  if (!asset) return null;
  const url = asset.video?.url || asset.file?.url;
  const thumbnail = asset.video?.thumbnail;
  if (!url && !thumbnail) return null;
  return {
    url,
    thumbnail,
    key: asset.video?.key || asset.file?.key || asset.videoKey,
  };
}

/** Documents attached to a lesson (supports legacy documentUrl). */
export function getAssetDocuments(asset) {
  return (asset?.documents || []).filter(
    (doc) => doc && (doc.url || doc.documentUrl)
  );
}

export function assetFileDisplayName(file) {
  if (!file) return '';
  if (file.name) return file.name;

  const segment = (file.filename || file.url || file.key || '')
    .split('/')
    .filter(Boolean)
    .pop() || '';

  try {
    return decodeURIComponent(segment).replace(/^\d+-/, '');
  } catch {
    return segment.replace(/^\d+-/, '');
  }
}
